import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { Observable } from 'rxjs';
import { LoaderService } from '../loader/loader.service';

type IAction =
  | 'retrieve'
  | 'retrieveSingle'
  | 'add'
  | 'delete'
  | 'edit'
  | 'login'
  | 'register'
  | 'reportSheet'
  | 'downloadReportCard'
  | 'downloadResultSheet'
  | 'downloadPromotionReport'
  | 'file-upload'
  | 'courseAverage'
  | 'assignCourses'
  | 'assignCourseToClassrooms'
  | 'unassignCourses'
  | 'removeFromClassroom'
  | 'registerLearners'
  | 'classMasterSheet'
  | 'forgotPassword'
  | 'resetPassword'
  | 'addFeeStructure'
  | 'editFeeStructure'
  | 'deleteFeeStructure'
  | 'getFeeStructures'
  | 'getSingleFeeStructure'
  | 'fee-payment'
  | 'fee-receipt'
  | 'fee-statistics'
  | 'learner-payments'
  | 'sequenceEvaluations'
  | 'mergeClassrooms'
  | 'downloadClassMasterSheet'
  | 'download-class-report-cards'
  | 'generateTranscript'
  | 'bulk-delete-timeTables'
  | 'bulk-delete'
  | 'getTeacherTimeTable'
  | 'getClassroomTimeTable'
  | 'getCourseTimeTable'
  | 'checkConflicts'
  | 'toggleStatus'
  | 'createRecurring'
  | 'updateRecurringSeries'
  | 'deleteRecurringSeries'
  | 'getStats'
  | 'export'
  | 'import';

interface IRequest {
  path: string;
  action?: IAction;
  method: 'get' | 'post' | 'put' | 'delete';
  options?: {
    body?: any;
    params?: any;
    id?: any;
    headers?: any;
    responseType?: 'json' | 'arraybuffer' | 'blob' | 'text' | 'arraybuffer';
  };
  loader?: {
    type?: 'spinner' | 'button' | 'skeleton';
  };
  isAuthRoutes?: boolean;
  endpointType?: 'auth' | 'app' | 'online';
}
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private baseUrl: string = ApiRoutes.api.host + 'api/v1/';
  private routes = ApiRoutes.api;

  constructor(
    private readonly http: HttpClient,
    private readonly loaderService: LoaderService
  ) {}

  makeRequest(payload: IRequest): Observable<any> {
    // Extract URL params from options
    const urlParams = payload?.options?.params || {};
    const { id, ...restOptions } = payload?.options || {};
    
    
    let baseEndpoint: string;
    
    if (payload.endpointType) {
      baseEndpoint = `${payload.endpointType}/`;
    } else {
      baseEndpoint = !payload.isAuthRoutes ? 'auth/' : 'app/';
    }
    
    const url = new URL(`${this.baseUrl}${baseEndpoint}${payload.path}`);
    
    // Add ID to path if present
    if (id) {
      url.pathname = url.pathname.replace(/\/?$/, `/${id}`);
    }

    // Add URL parameters
    Object.entries(urlParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        url.searchParams.append(key, value.toString());
      }
    });

    restOptions.params = url.searchParams;

    // Show loader
    this.loaderService.showLoader({
      route: url.toString(),
      type: payload?.loader?.type || 'spinner',
    });

    // Make request with cleaned up options
    return this.http.request(
      payload.method,
      url.toString(),
      Object.keys(restOptions).length ? restOptions : undefined
    );
  }
}
